import React from "react";
import { useParams } from "react-router-dom";

import styled from "styled-components";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useLazyQuery } from "@apollo/client";

import ActionPageHero from "../../molecules/ActionPageHero";
import { PrimaryButton, OutlineButton } from "../../atoms/Buttons";
import { DarkFormField } from "../../atoms/Inputs";
import { P, H2 } from "../../atoms/Texts";
import { ErrorMessage } from "@hookform/error-message";
import RoutesTabs from "../InitiativeTab";
import { InitiativeCard } from "../../atoms/Cards";

import { SEARCH_INITIATIVE } from "../../../shared/queries";

const InitiativesLayoutStyle = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InitiativesLayout = (props) => {
  const { id } = useParams();

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm();

  const query = watch("search");

  const [searchInitiative, { loading, data }] = useLazyQuery(SEARCH_INITIATIVE);

  const onSearch = (data) => {
    if (query.length > 1) {
      searchInitiative({
        variables: {
          search: data.search,
        },
      });
    }
  };

  return (
    <InitiativesLayoutStyle>
      <ActionPageHero
        className="organization-container"
        title="Initiatives"
        description="Opting into an initiative lets you receive referrals and manage cases from members of that initiative and enhances impact tracking"
        pClassName="lg:w-2/3"
        action
        actionComponent={null}
      />

      <div className="organization-container pb-10 flex-grow flex flex-col mt-6">
        <section>
          <div className="flex justify-between items-start ">
            <form
              onSubmit={handleSubmit(onSearch)}
              className="lg:w-1/2 flex flex-wrap lg:flex-no-wrap gap-4"
            >
              <div className="w-full flex-grow ">
                <DarkFormField
                  type="search"
                  id="search"
                  name="search"
                  className="py-1 flex w-full"
                  placeholder="Search"
                  iconBeforeClass=""
                  data_testid="search-input"
                  {...register("search")}
                />
                <ErrorMessage
                  errors={errors}
                  name="search"
                  as={
                    <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />
                  }
                >
                  {({ messages }) =>
                    messages &&
                    Object.entries(messages).map(([type, message]) => (
                      <P key={type}>{message}</P>
                    ))
                  }
                </ErrorMessage>
              </div>
              <div>
                <PrimaryButton>{loading ? "Loading.." : "Search"}</PrimaryButton>
              </div>
            </form>

            <div>
              <Link to={`/dashboard/organization/${id}/initiatives/add`}>
                <OutlineButton color="#442ED0">Initiative Request</OutlineButton>
              </Link>
            </div>
          </div>

          {/* search result */}

          <div className="py-8">
            {loading ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <>
                  {Array(3)
                    .fill("")
                    .map((_, i) => (
                      <div key={i} className="bg-white py-6 px-4">
                        <div className="animate-pulse rounded-md bg-gray-400 opacity-75 h-6 w-full md:w-2/3 mb-2"></div>
                        <div className="animate-pulse rounded-md bg-gray-400 opacity-75 w-full h-5 "></div>

                        <div className="flex items-center justify-between w-full mt-16">
                          <div className="animate-pulse rounded-md bg-gray-400 opacity-75 h-5 w-1/2"></div>
                          <div className="animate-pulse rounded-md bg-gray-400 opacity-75 h-5 w-1/3"></div>
                        </div>
                      </div>
                    ))}
                </>
              </div>
            ) : query?.length > 1 && data?.searchInitiatives?.length > 0 ? (
              <div>
                <div>
                  <H2 fontSize="16px">Search results:</H2>
                </div>

                <div className="mt-4 grid grid-cols-1 md:grid-cols-2  gap-8">
                  {data?.searchInitiatives?.map((item) => (
                    <InitiativeCard key={item.id} initiative={item} />
                  ))}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </section>

        <div className="mt-10">
          <RoutesTabs
            data={[
              {
                id: 1,
                name: "My Initiatives",
                href:
                  `/dashboard/organization/${id}/initiatives` ||
                  `/dashboard/organization/${id}/initiatives/all`,
              },
              {
                id: 2,
                name: "Opt-in Request",
                href: `/dashboard/organization/${id}/initiatives/opt`,
              },
              {
                id: 3,
                name: "Invites",
                href: `/dashboard/organization/${id}/initiatives/pending`,
              },
            ]}
          />

          <section className="py-6 border-t border-gray-300">
            {props.children}
          </section>
        </div>
      </div>
    </InitiativesLayoutStyle>
  );
};
